import { render } from "./TransactionSuccessfulModalComponent.vue?vue&type=template&id=a76d18a4&ts=true"
import script from "./TransactionSuccessfulModalComponent.vue?vue&type=script&lang=ts"
export * from "./TransactionSuccessfulModalComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__